import { Box } from "@mui/material"
import React from "react"
import { useShallow } from "zustand/shallow"

import { UOM_RENDER_PRECISION } from "@/constants/formats"
import type { Order } from "@/graphql/codegen/graphql"
import { formatPalletCount } from "@/screens/WarehouseReceiving/utils"
import { useUnitOfMeasurementsStore } from "@/stores/unitOfMeasurmentsStore"
import { formatNumber } from "@/utils/number"
import { getTotalSummaryPurchaseOrder } from "@/utils/purchaseOrder"

interface PurchaseOrderQuantityPalletsCellProps {
  order: Order
}

export const PurchaseOrderQuantityPalletsCell: React.FC<PurchaseOrderQuantityPalletsCellProps> = ({ order }) => {
  const units = useUnitOfMeasurementsStore(useShallow((s) => s.units))
  const { totalWeight, totalPallets } = getTotalSummaryPurchaseOrder({ orderLines: order?.orderLines ?? [] })
  const usUom = units.find((u) => u.id === totalWeight.us.uomId)

  return (
    <Box>
      {formatPalletCount(totalPallets)} ({formatNumber(totalWeight.us.amount, UOM_RENDER_PRECISION)} {usUom?.name})
    </Box>
  )
}
